/**************  CSS  **************/
import './MainPage.css'

/**********  React hooks  **********/
import { useState } from 'react'

/**********  Components  ***********/
import MenuElement from '../../Assets/Menu/MenuElement'
import Theme from '../../Assets/Theme/Theme'
import TrainLength from '../TrainLength/TrainLength'
import Speed from '../Speed/Speed'

/************  Others  *************/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function MainPage() {
    const [menuID, setMenuID] = useState(0)

    return <div>
        <div className='tda-MainPage-Content'>
            {menuID === 0 ? <TrainLength /> : false}
            {menuID === 1 ? <Speed /> : false}
            {menuID === 2 ? false : false}
            {menuID === 3 ? false : false}
        </div>
        <div className='tda-MainPage-Menu'>
            <MenuElement icon={<FontAwesomeIcon icon="fa-solid fa-ruler" />} thisMenuID={0} setMenuID={setMenuID} currentMenuID={menuID} />
            <MenuElement icon={<FontAwesomeIcon icon="fa-solid fa-gauge-high" />} thisMenuID={1} setMenuID={setMenuID} currentMenuID={menuID} />
            <MenuElement icon={<FontAwesomeIcon icon="fa-solid fa-gear" />} thisMenuID={2} setMenuID={setMenuID} currentMenuID={menuID} />
            <MenuElement icon={<FontAwesomeIcon icon="fa-solid fa-code" />} thisMenuID={3} setMenuID={setMenuID} currentMenuID={menuID} />
            <Theme asButton={false} className='tda-MenuElement' />
        </div>
    </div>
}